export var PositionGeneralContent;
(function (PositionGeneralContent) {
    PositionGeneralContent["Bow"] = "bow";
    PositionGeneralContent["Starboard"] = "starboard";
    PositionGeneralContent["Port"] = "port";
    PositionGeneralContent["Stern"] = "stern";
})(PositionGeneralContent || (PositionGeneralContent = {}));
//# sourceMappingURL=PositionGeneralContent.js.map